export const MagnifyingGlassIcon: React.FC = () => {
	return (
		<svg
			fill="none"
			height="21"
			viewBox="0 0 21 21"
			width="21"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.7499 19.6894L15.0859 14.0253C16.4469 12.3913 17.1256 10.2955 16.9808 8.17387C16.8359 6.05224 15.8787 4.06812 14.3082 2.63426C12.7378 1.20041 10.675 0.427212 8.54894 0.475524C6.42292 0.523836 4.39736 1.38993 2.89365 2.89365C1.38993 4.39736 0.523836 6.42292 0.475524 8.54894C0.427212 10.675 1.20041 12.7378 2.63426 14.3082C4.06812 15.8787 6.05224 16.8359 8.17387 16.9808C10.2955 17.1256 12.3913 16.4469 14.0253 15.0859L19.6894 20.7499L20.7499 19.6894ZM1.99993 8.74993C1.99993 7.41491 2.39581 6.10987 3.13751 4.99983C3.87921 3.8898 4.93342 3.02464 6.16682 2.51375C7.40022 2.00285 8.75742 1.86918 10.0668 2.12963C11.3762 2.39008 12.5789 3.03296 13.5229 3.97696C14.4669 4.92097 15.1098 6.1237 15.3702 7.43307C15.6307 8.74245 15.497 10.0996 14.9861 11.333C14.4752 12.5664 13.6101 13.6207 12.5 14.3624C11.39 15.1041 10.085 15.4999 8.74993 15.4999C6.96033 15.4979 5.2446 14.7862 3.97916 13.5207C2.71371 12.2553 2.00192 10.5395 1.99993 8.74993Z"
				fill="#64748b"
			/>
		</svg>
	);
};
